/* eslint-disable */

// Core
import Vue from 'vue';
import Router from 'vue-router';
// Views
import Dashboard from './views/Dashboard.vue';
import Errors from './views/Errors.vue';
import Login from './views/Login.vue';
import LoginTwoFactor from './views/LoginTwoFactor.vue';
import Logout from './views/Logout.vue';
import PasswordReset from './views/PasswordReset.vue';
import PasswordResetConfirm from './views/PasswordResetConfirm.vue';
import Slots from './views/Slots.vue';
import Splashscreen from './views/SplashScreen.vue';
// Subviews
import NoPermissions from './views/NoPermissions.vue';
// Helpers
import SanitizeUtils from './utils/SanitizeUtils';
// Popup content
import Hotels from './views/Hotels.vue';
import Airports from './views/Airports.vue';
import Agents from './views/Agents.vue';
import Aircrafts from './views/Aircrafts.vue';
import Countries from './views/Countries.vue';
import Customers from './views/Customers.vue';
import Passengers from './views/Passengers.vue';
import Crews from './views/Crews.vue';
import ChecklistTemplates from './views/ChecklistTemplates.vue';
import Monitoring from './views/Monitoring.vue';
import MyProfile from './views/MyProfile.vue';
import Notifications from './views/Notifications.vue';
import Settings from './views/Settings.vue';
import Trips from './views/Trips.vue';
import Users from './views/Users.vue';
import Warnings from './views/Warnings.vue';
import Activate2fa from './views/Activate2fa.vue';
import Deactivate2fa from './views/Deactivate2fa.vue';
import DocumentScanner from './views/DocumentScanner.vue';
// Forms
import AgentForm from './components/forms/AgentForm.vue';
import AirportForm from './components/forms/AirportForm.vue';
import AircraftForm from './components/forms/AircraftForm.vue';
import ChangePasswordForm from './components/forms/ChangePasswordForm.vue';
import CountryForm from './components/forms/CountryForm.vue';
import CrewForm from './components/forms/CrewForm.vue';
import CustomerForm from './components/forms/CustomerForm.vue';
import FlightForm from './components/forms/FlightForm.vue';
import HotelForm from './components/forms/HotelForm.vue';
import UserForm from './components/forms/UserForm.vue';
import PassengerForm from './components/forms/PassengerForm.vue';
import TripForm from './components/forms/TripForm.vue';

// Avoid NavigationDuplicated errors
const originalPush = Router.prototype.push;

Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch(error => {
    if (error.name !== 'NavigationDuplicated') {
      throw error;
    }
  });
}

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/login', component: Login, name: 'Login', meta: { layout: 'guest' } },
    { path: '/2fa/:token', component: LoginTwoFactor, name: 'LoginTwoFactor', meta: { layout: 'guest' } },
    { path: '/password-reset', component: PasswordReset, name: 'PasswordReset', meta: { layout: 'guest' } },
    { path: '/password/reset/:token/:email', component: PasswordResetConfirm, name: 'PasswordResetConfirm', meta: { layout: 'guest' } },
    { path: '/logout', component: Logout, name: 'Logout', },
    { path: '/loading', component: Splashscreen, name: 'Splashscreen' },
    { path: '/', redirect: '/dashboard' },
    {
      path: '/dashboard',
      component: Dashboard,
      name: 'Dashboard',
      children: [
        { path: '/dashboard/hotels', component: Hotels, name: 'Hotels', meta: { popup: true } },
        { path: '/dashboard/hotels/:id', component: HotelForm, name: 'HotelForm', meta: { popup: true } },
        { path: '/dashboard/airports', component: Airports, name: 'Airports', meta: { popup: true } },
        { path: '/dashboard/airports/:id', component: AirportForm, name: 'AirportForm', meta: { popup: true } },
        { path: '/dashboard/agents', component: Agents, name: 'Agents', meta: { popup: true } },
        { path: '/dashboard/agents/:id', component: AgentForm, name: 'AgentForm', meta: { popup: true } },
        { path: '/dashboard/aircrafts', component: Aircrafts, name: 'Aircrafts', meta: { popup: true } },
        { path: '/dashboard/aircrafts/:id', component: AircraftForm, name: 'AircraftForm', meta: { popup: true } },
        { path: '/dashboard/checklist-templates', component: ChecklistTemplates, name: 'ChecklistTemplates', meta: { popup: true } },
        { path: '/dashboard/countries', component: Countries, name: 'Countries', meta: { popup: true } },
        { path: '/dashboard/countries/:id', component: CountryForm, name: 'CountryForm', meta: { popup: true } },
        { path: '/dashboard/customers', component: Customers, name: 'Customers', meta: { popup: true } },
        { path: '/dashboard/customers/:id', component: CustomerForm, name: 'CustomerForm', meta: { popup: true } },
        { path: '/dashboard/passengers', component: Passengers, name: 'Passengers', meta: { popup: true } },
        { path: '/dashboard/passengers/:id', component: PassengerForm, name: 'PassengerForm', meta: { popup: true } },
        { path: '/dashboard/users', component: Users, name: 'Users', meta: { popup: true } },
        { path: '/dashboard/users/:id', component: UserForm, name: 'UserForm', meta: { popup: true } },
        { path: '/dashboard/crew', component: Crews, name: 'Crews', meta: { popup: true } },
        { path: '/dashboard/crews/:id', component: CrewForm, name: 'CrewForm', meta: { popup: true } },
        { path: '/dashboard/trips', component: Trips, name: 'Trips', meta: { popup: true } },
        { path: '/dashboard/trips/:id', component: TripForm, name: 'TripForm', meta: { popup: true } },
        { path: '/dashboard/trips/new/:aircraft_id', component: TripForm, name: 'TripFormWithAircraftID', meta: { popup: true } },
        { path: '/dashboard/slots', component: Slots, name: 'Slots', meta: { popup: true }},
        { path: '/dashboard/fligths/:flight_id', component: FlightForm, name: 'FlightForm', meta: { popup: true } },
        { path: '/dashboard/fligths/:flight_id/:section_name', component: FlightForm, name: 'FlightFormSection', meta: { popup: true } },
        { path: '/dashboard/warnings', component: Warnings, name: 'Warnings', meta: { popup: true } },
        { path: '/dashboard/monitoring', component: Monitoring, name: 'Monitoring', meta: { popup: true } },
        { path: '/dashboard/monitoring/view/:id', component: Monitoring, name: 'MonitoringView', meta: { popup: true } },
        { path: '/dashboard/notifications', component: Notifications, name: 'Notifications', meta: { popup: true } },
        { path: '/dashboard/settings', component: Settings, name: 'Settings', meta: { popup: true } },
        { path: '/dashboard/my-profile', component: MyProfile, name: 'MyProfile', meta: { popup: true } },
        { path: '/dashboard/change-password', component: ChangePasswordForm, name: 'ChangePassword', meta: { popup: true } },
        { path: '/dashboard/change-password/:type', component: ChangePasswordForm, name: 'YouMustChangeYourPassword', meta: { popup: true } },
        { path: '/dashboard/2fa/activate', component: Activate2fa, name: 'Activate2fa', meta: { popup: true } },
        { path: '/dashboard/2fa/deactivate', component: Deactivate2fa, name: 'Deactivate2fa', meta: { popup: true } },
        { path: '/dashboard/document-scanner', component: DocumentScanner, name: 'DocumentScanner', meta: { popup: true } }
      ]
    },
    { path: '/404', component: Errors },
    { path: '/no-permissions', component: NoPermissions },
    { path: '*', redirect: '/404' }
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Login',
    'LoginTwoFactor',
    'Logout',
    'PasswordReset',
    'PasswordResetConfirm'
  ];

  if (notLoggedInRoutes.indexOf(to.name) === -1 && !SanitizeUtils.getToken()) {
    let splashscreenHtml = document.querySelector('#splashscreen');
    let urlRedirect = null;

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    if (to && to.path.indexOf('/dashboard/monitoring/view/') > -1) {
      urlRedirect = '/dashboard/monitoring/view/' + parseInt(to.params.id, 10);
    }

    sessionStorage.setItem('login-redirect', urlRedirect);
    next({ name: 'Login' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next();
    return;
  }

  let calendarRefreshRoutes = [
    'Airports',
    'AirportForm',
    'Aircrafts',
    'AircraftForm',
    'Countries',
    'CountryForm'
  ];

  if (window.crmRefreshCalendar && calendarRefreshRoutes.indexOf(from.name) !== -1 && to.name === 'Dashboard') {
    window.crmRefreshCalendar();
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        }
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  next();
});

export default router;
